module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.layout) ? [_c('div', {
    staticClass: "containers"
  }, [_c('div', {
    staticClass: "left-block hidden-xs hidden-print"
  }, [_c('div', [_c('ul', {
    staticClass: "nav"
  }, [_c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'reservations'
      },
      "exact": ""
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-date"
  }), _vm._v(" "), _c('span', [_vm._v("Overview")])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'breakfasts'
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-wine"
  }), _vm._v(" "), _c('span', [_vm._v("Breakfasts")])])])], 1), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'rooms.available'
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-unlock"
  }), _vm._v(" "), _c('span', [_vm._v("Available rooms")])])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'cleaning'
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-door-lock"
  }), _vm._v(" "), _c('span', [_vm._v("Cleaning")])])])], 1), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'reporting'
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-graph"
  }), _vm._v(" "), _c('span', [_vm._v("Reporting")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'statistics'
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-graph3"
  }), _vm._v(" "), _c('span', [_vm._v("Danmarks Statistik")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'products'
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-cart"
  }), _vm._v(" "), _c('span', [_vm._v("Products")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'rooms'
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-home"
  }), _vm._v(" "), _c('span', [_vm._v("Rooms")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-tools"
  }), _vm._v(" "), _c('span', [_vm._v("Settings")])])])], 1) : _c('li', [_c('a', {
    staticClass: "navigatable",
    on: {
      "click": _vm.signOut
    }
  }, [_vm._m(0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-block"
  }, [_c('router-view')], 1), _vm._v(" "), _c('reservation-overlay')], 1), _vm._v(" "), _c('div', {
    staticClass: "search-container hidden-print visible-lg visible-md"
  }, [_c('search')], 1)] : _c('router-view'), _vm._v(" "), _c('key-navigation')], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "icon pe-7s-tools"
  }), _vm._v(" "), _c('span', [_vm._v("Sign out")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 393
// module chunks = 1